export default "__VITE_ASSET__373f811f__"